import React, { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";

const PlanCard = ({plan, onSelectPlan, user, setSelectedPlanId, isMonthly}) => {
    const isSelected = plan?.highlight;

    const handleClick = (plan) => {
        setSelectedPlanId(plan?.id);
        onSelectPlan(plan);
    }
    
    const formatPrice = (priceInINR, countryCode) => {
        if (countryCode === "91") {
          return {
            symbol: "₹",
            amount: priceInINR,
          };
        } else {
          const converted = (priceInINR / 83).toFixed(2);
          return {
            symbol: "$",
            amount: converted,
          };
        }
    };

    const { symbol, amount } = formatPrice(plan?.base_price, user?.country_code);

    return (
        <div
            className={`relative flex flex-col justify-between items-center text-center px-6 py-10 shadow-md rounded-lg transition-transform hover:cursor-pointer ${plan?.highlight ? "text-white border-[#0C1831] bg-[#0C1831] scale-105" : "bg-white text-gray-800 border-gray-200 hover:shadow-lg"}`}
            onClick={() => setSelectedPlanId(plan?.id)}
        >
            {plan?.isRecommended && (
                <span className="absolute top-2 right-2 bg-gray-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
                    Recommended
                </span>
            )}

            <h3 className="text-xl font-semibold mb-2">{plan?.name}</h3>
            <div className="flex">
                <p className="text-3xl font-bold mb-1">{symbol}{amount}</p>
                <p className="text-sm font-medium mt-4 ms-1">Per {isMonthly ? "Month" : "Year"}</p>
            </div>
            <ul className="space-y-3  mb-8 text-left w-full">
                <li className="flex items-center gap-2">
                    <FaCheckCircle className="text-blue-500" />
                    <span>{plan?.item_limits.drones.limit < 0 ? `Unlimited Drones` : `Up to ${plan?.item_limits.drones.limit} Drones`}</span>
                </li>
                <li  className="flex items-center gap-2">
                    <FaCheckCircle className="text-blue-500" />
                    <span>{plan?.item_limits.locations.limit < 0 ? `Unlimited Locations` : `Up to ${plan?.item_limits.locations.limit} Locations`}</span>
                </li>
                <li className="flex items-center gap-2">
                    <FaCheckCircle className="text-blue-500" />
                    <span>Up to 10 Team Members</span>
                </li>
                <li className="flex items-center gap-2">
                    <FaCheckCircle className="text-blue-500" />
                    <span>{plan?.item_limits.leads.limit < 0 ? `Unlimited Leads` : `Up to ${plan?.item_limits.leads.limit}`}</span>
                </li>
                <li className="flex items-center gap-2">
                    <FaCheckCircle className="text-blue-500" />
                    <span>Up to 1 Crop</span>
                </li>
                <li className="flex items-center gap-2">
                    <FaCheckCircle className="text-blue-500" />
                    <span>Access Order Management</span>
                </li>
                <li className="flex items-center gap-2">
                    <FaCheckCircle className="text-blue-500" />
                    <span>Access Customer Management</span>
                </li>
            </ul>

            <button
                className={`px-5 py-2 rounded-lg w-full font-medium transition bg-blue-600 text-white hover:bg-blue-700 `}
                onClick={() => handleClick(plan)}
            >
                 Get This Plan
            </button>
        </div>
    );
};

export default PlanCard;